import ConnectAPI from "../../../services/api";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import { Col, Container, Row, ThemeProvider } from "react-bootstrap";
import { Select, TextBox, Table, DatePicker, TextArea, Button, Checkbox, FilePicker, Stepper, IconCheckmark, IconPlus, IconListView, IconTrash, Tooltip, IconInfo, Modal, IconMinus  } from '@veneer/core';
//import SpecialConditionType from './SpecialConditionType';

function NewSpecialConditionsProcess(props){
    const connectApi = new ConnectAPI();
    const { t } = useTranslation();
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    //const [isLoading, setIsLoading] = useState(false);


    //Copeado
    /* Metodos para guardar las condiciones especiales. */
    const [oneShotDisabled, setOneShotDisabled] = useState(false)
    const [whiteDisabled, setWhiteDisabled] = useState(false)
    const [segmentSelected, setSegmentSelected] = useState("")

    const [isLastTier, setIsLastTier] = useState(false)
    const [minPrint, setMinPrint] = useState(1)
    const [maxPrint, setMaxPrint] = useState("")

    const [blackCpp, setBlackCpp] = useState("")
    const [otherCpp, setOtherCpp] = useState("")
    const [oneShotCpp, setOneShotCpp] = useState("")
    const [whiteCpp, setWhiteCpp] = useState("")
    const [compensationTable, setCompensationTable] = useState([])
    const [lowCoverage, setLowCoverage] = useState(false)

    const [category, setCategory] = useState([])
    const [channelList, setChannelList] = useState([])
    const [viewChannel, setViewChannel] = useState(false)
    const [channel, setChannel] = useState("")
    const [endUserList, setEndUserList] = useState([])
    const [endUser, setEndUser] = useState("")
    const [serieFix, setSerieFix] = useState("")
    const [seriesList, setSeriesList] = useState([])
    const [selectedPress, setSelectedPress] = useState(false)
    const [series, setSeries] = useState("")
    const [pressListBySeries, setPressListBySeries] = useState ([])
    const [pressListBySeriesFilter, setPressListBySeriesFilter] = useState ([])
    const [specialConditionTypeList, setSpecialConditionTypeList] = useState ([])
    const [specialConditionType, setSpecialConditionType] = useState("")
    const [segment, setSegment] = useState([])
    const [segmentFlag, setSegmentFlag] = useState(false)
    const [startDate, setStartDate] = useState("")
    const [opdNumber, setOpdNumber] = useState("")
    const [effectiveMonths, setEffectiveMonths] = useState(1)
    const [objetive, setObjetive] = useState("")
    const [justification, setJustification] = useState("")
    const [competition, setCompetition] = useState("")
    const [resultFuture, setResultFuture] = useState("")
    const [comments, setComments] = useState("")
    const [endUserContactName, setEndUserContactName] = useState("")
    const [endUserContactPosition, setEndUserContactPosition] = useState("")
    const [endUserEmail, setEndUserEmail] = useState("")
    const [file, setFile] = useState("")
    const [showModalSegment, setShowModalSegment] = useState(false)
    const [showMessage, setShowMessage] = useState("")
    const [previusInformation, setPreviusInformation] = useState(false)
    const [informationFromHP, setInformationFromHP] = useState(false)

    const resetDefaul = () => {
        setEndUser("");
        setSerieFix("");
        setSeriesList([]);
        setSelectedPress(false);
        setSeries("");
        setPressListBySeries([]);
        setPressListBySeriesFilter([]);
        setSpecialConditionTypeList([]);
        setSpecialConditionType("");
        setSegment([]);
        setSegmentSelected("");
        setStartDate("");
        setOpdNumber("")
        setEffectiveMonths(1);
        setObjetive("");
        setJustification("");
        setCompetition("");
        setResultFuture("");
        setComments("");
        setMinimumImp(0);
        setPercentage();
        if(informationFromHP) 
            setPreviusInformation(true);
        else {
            setChannel("");
            setEndUserList([]);
            setCategory([]);
        }
    }

    useEffect(() => {
        //validate location
        let validate = false;
        currentUser.urls.forEach( ur => {
            if ( ur == window.location.pathname ) validate=true;
        });
        if (validate==false){
            const { history } = props;
            history.push({ pathname: '/' });
        }//end validate

        //console.log("-------------------------currentUser------------------------")
        //currentUser.idCustomer = "CL0047"; currentUser.idRole = 5;

        if(currentUser.idRole == 5 ) {// 5 - Sales Op Admin  
            setPreviusInformation(true);
            setInformationFromHP(true);
        }

        setEndUserContactName(currentUser.name);
        setEndUserContactPosition(currentUser.jobPosition);
        setEndUserEmail(currentUser.email);

        const fetchData = () => {
            connectApi.get( "api/Channels", "", ChannelListData ).catch(
                (error) => {
                    Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
                }
            );
        };
        const ChannelListData = (status, data) => {
            const items = data.map((item) => {
                if (item.type != "Inactive")
                    return{ value: item.idCustomer, label: item.name };
            });
            let channels = items.filter(x => x)
            if (currentUser.idCustomer == "HP"){
                setChannelList(channels);
                setCategory([2]);
            } else {
                let channelSelect = channels.filter(x => x.value == currentUser.idCustomer);
                setChannelList(channelSelect);
                setChannel([channelSelect[0].value]);
                fetchEndUsers(currentUser.idCustomer);
                setCategory([1]);
                setViewChannel(true);
            }
        };

        fetchData();
    }, []);

    const EndUserListData = (status, data) => {
        const items = data.filter((item) => {
            const numerosFiltrados = item.pressList.split(',').map(num => num.trim()).filter(num => parseInt(num.charAt(0), 10) >= 4);
            return numerosFiltrados.length > 0;
        }).map((item) => {
            return { value: item.idEndUser, label: item.endUserName };
        });
        setEndUserList(items);
        setEndUserListCombineClicks(items);
    };
    const fetchEndUsers = (channel) => {
        connectApi.get( "api/Channels/endUsers", {
            params:{ customerId: channel, status: "Active" }
        }, EndUserListData )
        .catch( (error) => {
            Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
        });
    };
    useEffect(() => { setPressListBySeriesFilter(pressListBySeries.filter((item) => item.series == series && item.segment == segment)); }, [series]);
    const PressListData = (status, data) => {
        const filterData = data.filter(item => item.series >= 3);
        if (filterData.length == 0) setSegmentFlag(true);

        setPressListBySeries(filterData);
        for (let i = 0; i < filterData.length; i++){
            Object.assign(filterData[i],{uid:i, rowConfig:{ selected:false }}); 
        }
        if (filterData.length > 0){
            let array = filterData.map(x => x.segment).filter((x, idx, item) => item.indexOf(x) === idx ).map(x => x );
            if(array.length == 1){
                setSegment(array);
                setSegmentSelected(array[0].segment);
                setSegmentFlag(true);
                let array2 = filterData.map(x => x.series).filter((x, idx, item) => item.indexOf(x) === idx ).map(x => {return{ value: x, label: x } });
                setSeriesList(array2)
                if(array2.length == 1){
                    if(array2[0].value >= 3)
                        setSerieFix([array2[0].value]);
                    else
                        setSeries([array2[0].value]);
                    if(array2[0].value >= 3 && array.length == 1)
                        fetchSpConditions(array2[0].value);
                } else
                    setSeries("");
            } else {
                setSegment([]);
                setSegmentFlag(false);
                setSegmentSelected("");
            }
        } else
            setSeriesList([]);
    };
    let xUser = "";
    const fetchPress = (endUser) => {
        xUser=endUser;
        connectApi.get("api/Channels/endUsers/" + endUser + "/ActivePresses",
        { params:{ endUserId: endUser } }, PressListData).catch((error) => {
            Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
        });
    };
    const SpConditionListData = (status, data) => {
        const items = data.map((item) => {
            return{ value: item.idSpecialConditionType, label: item.specialConditionType };
        });
        if(items.length == 1)
            setSpecialConditionType([items[0].value])
        setSpecialConditionTypeList(items);
    };
    const fetchSpConditions = (serie) => {
        let interUser = endUser[0];
        if(endUser[0]==undefined || endUser[0]=="" )
            interUser = xUser;
        setSeries([serie]);
        connectApi.get("api/Channels/SpConditionType", { params:{ series: serie, idenduser: interUser } }, SpConditionListData)
        .catch((error) => {
            Swal.fire( "Error " + error?.response?.status, error?.response?.data, "error" );
        });
    };

    function selectionState(dataArray) {
        const total = dataArray.length;
        const selected = dataArray.filter((row) => row.rowConfig.selected).length;
        switch (selected) {
            case 0: return 'none';
            case total: return 'all';
            default: return 'indeterminated';
        }
    }
    function setSegmentFind(segment){
        setSegment([segment]);
        setSegmentSelected(segment);

        if(serieFix!="")
            fetchSpConditions(serieFix);

        let array = pressListBySeries.filter((item) => item.segment == segment).map(x => x.series).filter((x, idx, item) => item.indexOf(x) === idx ).map(x => {return{ value: x, label: x } });
        setSeriesList(array)
        
        if(array.length == 1)
            fetchSpConditions(array[0].value);
        else 
            setSeries("");
    }


    /// aqui Comenza en codigode lsa Special Conditions(El rellenado)
    const [multiplierConfig, setMultiplierConfig] = useState(1)
    // copeado 2 
    const showMaxCostPerImpression = () => {
            const handleClick = () => {
                let obj = [...compensationTable];
                if (maxPrint == ""){
                    alert(t('alertMaxCost1'))
                } else if (maxPrint < minPrint) {
                    alert(t('alertMaxCost2') + (minPrint) + ".")
                } else if ( (blackCpp > 0.99999999 || blackCpp == "") || (otherCpp > 0.99999999 || otherCpp == "") 
                    || ((oneShotCpp > 0.99999999 || oneShotCpp == "") && !oneShotDisabled) || ((whiteCpp > 0.99999999 || whiteCpp == "") && !whiteDisabled) ){
                    alert(t('alertMaxCost3'))
                } else {
                    obj.push({"minPrint":minPrint,"maxPrint":maxPrint,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                    setMinPrint(maxPrint+1);
                    setMaxPrint("");
                    setBlackCpp(""); setOtherCpp(""); setOneShotCpp(""); setWhiteCpp("");
                    setCompensationTable(obj);
                }
            };
            const handleClickLess = () => {
                if (compensationTable.length === 0) return;
                let obj = [...compensationTable];
                obj.pop();
                setCompensationTable(obj);
                if (obj.length > 0) {
                    let lastRemainingItem = obj[obj.length - 1];
                    setMinPrint(Number(lastRemainingItem.maxPrint) + 1);
                } else setMinPrint(1);
            };
    
            const handleLast = () => {
                let obj = [...compensationTable];
                if ( (blackCpp > 0.99999999 || blackCpp == "") || (otherCpp > 0.99999999 || otherCpp == "") 
                    || ((oneShotCpp > 0.99999999 || oneShotCpp == "") && !oneShotDisabled) || ((whiteCpp > 0.99999999 || whiteCpp == "") && !whiteDisabled) )
                    alert(t('alertMaxCost3'))
                else {
                    if(!(specialConditionType == 13))
                        obj.push({"minPrint":minPrint,"maxPrint":999999999,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                    else
                        obj.push({"minPrint":minPrint,"maxPrint":999,"blackCpp":blackCpp,"otherCpp":otherCpp,"oneShotCpp":oneShotCpp,"whiteCpp":whiteCpp});
                    setMinPrint(1);
                    setMaxPrint("");
                    setBlackCpp(""); setOtherCpp(""); setOneShotCpp(""); setWhiteCpp("");
                    setCompensationTable(obj);
                    setIsLastTier(true);
                }
            };
    
            if (specialConditionType == 1 || specialConditionType == 13 || specialConditionType == 22  || specialConditionType == 23 || specialConditionType==26){
                return(
                    <>
                    {(seriesList.find(e=>e.globalaccount===true) && [26,22].includes(specialConditionType))?(<></>):(<>
                        <br />
                        <Row>
                            <br />
                            <Col md="12">
                                <h4 style={{marginLeft:"35%"}}> {t('bonus')} Maximum CPP </h4>
                            </Col>
                            <br />
                            <Col xs="4" md="4">
                                {specialConditionType == 13?(<>
                                <TextBox
                                    id="min-print"
                                    label="Min LS Mark"
                                    maxLength="3"
                                    value={minPrint}
                                    disabled
                                /><br />
                                <TextBox
                                    id="max-print"
                                    label="Max LS Mark"
                                    maxLength="3"
                                    value={maxPrint}
                                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                    onChange={(e) => {if(e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                                    disabled={isLastTier}
                                /><br />
                                </>):(<>
                                <TextBox
                                    id="min-print"
                                    label={t('bonustable.table1')}
                                    maxLength="9"
                                    value={minPrint}
                                    disabled
                                /><br />
                                <TextBox
                                    id="max-print"
                                    label={t('bonustable.table2')}
                                    maxLength="9"
                                    value={maxPrint}
                                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                    onChange={(e) => {if(e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                                    disabled={isLastTier}
                                /><br />
                                </>)}
                                <TextBox
                                    id="black-cpp"
                                    label={t('prices.blackcommprice')}
                                    maxLength="10"
                                    value={blackCpp}
                                    onChange={(e) => { if(!isNaN(e)) setBlackCpp(e); }}
                                    disabled={isLastTier}
                                /><br />
                                <TextBox
                                    id="other-cpp"
                                    label={t('prices.othercommprice')}
                                    maxLength="10"
                                    value={otherCpp}
                                    onChange={(e) => { if(!isNaN(e)) setOtherCpp(e); }}
                                    disabled={isLastTier}
                                /><br />
                                <TextBox
                                    id="one-shot-cpp"
                                    label={t('prices.oneshotcommprice')}
                                    maxLength="10"
                                    value={oneShotCpp}
                                    onChange={(e) => { if(!isNaN(e)) setOneShotCpp(e); }}
                                    disabled={isLastTier?true:oneShotDisabled?true:false}
                                /><br />
                                <TextBox
                                    id="white-cpp"
                                    label={t('prices.whitecommprice')}
                                    maxLength="10"
                                    value={whiteCpp}
                                    onChange={(e) => { if(!isNaN(e)) setWhiteCpp(e); }}
                                    disabled={isLastTier?true:whiteDisabled?true:false}
                                /><br />
                                <div style={{
                                    display: 'flex', 
                                    flexDirection: 'column', 
                                    gap: '12px', 
                                }}>
                                    <Button
                                        id="add-to-compensation-array"
                                        onClick={handleClick}
                                        leadingIcon={<IconPlus />}
                                        disabled={isLastTier}
                                    >
                                        {t('addTier')}
                                    </Button>
                                    <Button
                                        id="less-to-compensation-array"
                                        onClick={handleClickLess}
                                        leadingIcon={<IconMinus />}
                                        disabled={isLastTier}
                                    >
                                        {t('clearTier')}
                                    </Button>
                                    <Button
                                        id="last-compensation-array"
                                        onClick={handleLast}
                                        leadingIcon={<IconListView />}
                                        disabled={isLastTier}
                                    >
                                        {t('lastTier')}
                                    </Button>
                                    <Button
                                        id="clear-compensation-array"
                                        appearance="secondary"
                                        leadingIcon={<IconTrash />}
                                        onClick={() => {
                                            setCompensationTable([]);
                                            setMinPrint(1);
                                            setMaxPrint("");
                                            setBlackCpp("");
                                            setOtherCpp("");
                                            setOneShotCpp("");
                                            setWhiteCpp("");
                                            setIsLastTier(false);
                                        }}
                                    >
                                        {t('clearTable')}
                                    </Button><br /><br />
                                </div>
                            </Col>
                            <Col xs="8" md="8">
                            <Table
                                name="bonus-table"
                                columns={[
                                    {
                                        id: "minPrint",
                                        label: specialConditionType == 13?("Min LS Mark %"):(t('bonustable.table1'))
                                    },
                                    {
                                        id: "maxPrint",
                                        label: specialConditionType == 13?("Max LS Mark %"):(t('bonustable.table2'))
                                    },
                                    {
                                        id: "blackCpp",
                                        label: t('prices.blackcommprice')
                                    },
                                    {
                                        id: "otherCpp",
                                        label: t('prices.othercommprice')
                                    },
                                    {
                                        id: "oneShotCpp",
                                        label: t('prices.oneshotcommprice')
                                    },
                                    {
                                        id: "whiteCpp",
                                        label: t('prices.whitecommprice')
                                    }
                                ]}
                                data={compensationTable} />
                                <br />
                                <p>{t('memoMaxCost1')}
                                    <ul style={{marginLeft:"40px"}}>
                                        <li><u>Indigo 1x000</u>: B2 (A3 <b>x 2</b>)</li>
                                        <li><u>Indigo 20000</u>: B1 (A3 <b>x 4</b>)</li>
                                        <li><u>Indigo 30000</u>: B2 (A3 <b>x 2</b>)</li>
                                    </ul>
                                </p><br />
                                <p>{t('memoMaxCost2')}
                                <ul style={{marginLeft:"40px"}}>
                                    <li><u>Indigo 1x000</u>: {t('memoMaxCost3')}</li>
                                    <li><u>Indigo 20000 &amp; 30000</u>: {t('memoMaxCost4')}</li>
                                </ul>
                                </p>
                            </Col>
                        </Row>
                    </>)}
                    
                    {specialConditionType == 23?(<>
                    <Checkbox
                        id = "id-low-coverage-box"
                        label = {t('credit') + " / " + t('debit') + " LSMark?"}
                        checked = {lowCoverage}
                        onChange = {(e) => {
                            setLowCoverage(e.target.checked);
                            setBonusLSDiscount([]);
                            setBonusLSDiscountSend([]);
                            setMinPrintLS(1);
                            setMaxPrintLS("");
                            setBonusLS("");
                            setIsLastTierLS(false);
                            setIsAddOneMin(false);
                        }}
                    />
                    <br />
                    </>):((specialConditionType==26?(<>
                        <Row>
                            <Col xs="4">
                                <TextBox
                                    id="minimum-impressions"
                                    label={"LSMark Minimum"}
                                    maxLength="9"
                                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                    onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                                />  
                                {(seriesList.find(e=>e.globalaccount===true))?(
                                    <>{t("notelifespandgateg")}</>
                                ):(<>{t("notelifespandgate")}</>)}
                            </Col>
                            <Col xs="4">
                                <TextBox
                                    id="fixed-bonus2"
                                    label="Percentage discount %"
                                    value={percentage}
                                    maxLength="3"
                                    onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                    onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e);  }}
                                />
                            </Col>
                        </Row>
                        
                    </>):("")))}
                    </>
                );
            } else {
                return null;
            };
        };
    
        // Bonus LSDisconunt Table
        const [bonusLSDiscount, setBonusLSDiscount] = useState([])
        const [bonusLSDiscountSend, setBonusLSDiscountSend] = useState([])
        const [bonusLS, setBonusLS] = useState("")
        const [minPrintLS, setMinPrintLS] = useState(1)
        const [maxPrintLS, setMaxPrintLS] = useState("")
        const [isAddOneMin, setIsAddOneMin] = useState(false)
        const [isLastTierLS, setIsLastTierLS] = useState(false)
    
        const showBonusLSDiscount = () => {
            const handleClick = () => {
                let obj = [...bonusLSDiscount];
                let objSend = [...bonusLSDiscountSend];
                if (maxPrintLS < 0 || isNaN(maxPrintLS) 
                    || minPrintLS < 0 || isNaN(minPrintLS)){
                    alert(t('alertMaxCost1'))
                } else if (maxPrintLS < minPrintLS) {
                    alert(t('alertMaxCost2'))
                } else if (isNaN(bonusLS)) {
                    alert(t('alertBonus'))
                } else {
                    obj.push({"minPrint":minPrintLS,"maxPrint":maxPrintLS, "bonus":`${(bonusLS)} %`});
                    setMinPrintLS(parseInt(maxPrintLS)+1);
                    setMaxPrintLS("");
                    setBonusLS("");
                    setBonusLSDiscount(obj);
                    objSend.push({"InitialLSMark":minPrintLS,"FinalLSMark":maxPrintLS, "Discount":bonusLS});
                    setBonusLSDiscountSend(objSend);
                    setIsAddOneMin(true);
                }
            };
            const handleClickLess = () => {
                if (bonusLSDiscount.length === 0) return;
                let obj = [...bonusLSDiscount];
                obj.pop();
                setBonusLSDiscount(obj);
                if (obj.length > 0) {
                    let lastRemainingItem = obj[obj.length - 1];
                    setMinPrintLS(Number(lastRemainingItem.maxPrint) + 1);
                } else setMinPrintLS(1);

                if (bonusLSDiscountSend.length === 0) return;
                let objSend = [...bonusLSDiscountSend];
                objSend.pop();
                setBonusLSDiscountSend(objSend);
                
            };
    
            const handleLast = () => {
                let obj = [...bonusLSDiscount];
                let objSend = [...bonusLSDiscountSend];
                if (isNaN(bonusLS) || bonusLS == "") {
                    alert(t('alertBonus'))
                } else {
                    obj.push({"minPrint":minPrintLS,"maxPrint":9999, "bonus":`${(bonusLS)} %`});
                    setMinPrintLS("");
                    setMaxPrintLS("");
                    setBonusLS("");
                    setBonusLSDiscount(obj);
                    objSend.push({"InitialLSMark":minPrintLS,"FinalLSMark":9999, "Discount":bonusLS});
                    setBonusLSDiscountSend(objSend);
                    setIsLastTierLS(true);
                }
            };
    
            if (specialConditionType == 22  || (specialConditionType == 23 && lowCoverage)){
                return(
                    <Row>
                        <br />
                        <Col md="12">
                            <h4 style={{marginLeft:"35%"}}> {t('bonus')} LSMark </h4>
                        </Col>
                        <br />
                        <Col xs="4" md="4">
                            <TextBox
                                id="min-print"
                                label={t("InitialLSMark")}
                                maxLength="4"
                                value={minPrintLS}
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if (e == "") setMinPrintLS(""); else setMinPrintLS(parseInt(e)); }}
                                disabled={isLastTierLS?true:isAddOneMin}
                            /><br />
                            <TextBox
                                id="max-print"
                                label={t("EndLSMark")}
                                maxLength="4"
                                value={maxPrintLS}
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if (e=="") setMaxPrintLS(""); else setMaxPrintLS(parseInt(e)); }}
                                disabled={isLastTierLS}
                            /><br />
                            <TextBox
                                id="bonus"
                                label={t('bonus') + " %"}
                                maxLength="5"
                                value={bonusLS}
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setBonusLS(e); }}
                                disabled={isLastTierLS}
                            /><br />
                            <div style={{
                                display: 'flex', 
                                flexDirection: 'column', 
                                gap: '12px', 
                            }}>
                                <Button
                                    id="add-to-bonus-array"
                                    onClick={handleClick}
                                    leadingIcon={<IconPlus />}
                                    disabled={isLastTierLS}
                                >
                                    {t('addTier')}
                                </Button>
                                <Button
                                    id="less-to-compensation-array"
                                    onClick={handleClickLess}
                                    leadingIcon={<IconMinus />}
                                    disabled={isLastTier}
                                >
                                    {t('clearTier')}
                                </Button>
                                <Button
                                    id="last-bonus-array"
                                    onClick={handleLast}
                                    leadingIcon={<IconListView />}
                                    disabled={isLastTierLS}
                                >
                                    {t('lastTier')}
                                </Button>
                                <Button
                                    id="clear-bonus-array"
                                    appearance="secondary"
                                    leadingIcon={<IconTrash />}
                                    onClick={() => {
                                        setBonusLSDiscount([]);
                                        setBonusLSDiscountSend([]);
                                        setMinPrintLS(1);
                                        setMaxPrintLS("");
                                        setBonusLS("");
                                        setIsLastTierLS(false);
                                        setIsAddOneMin(false);
                                    }}
                                >
                                    {t('clearTable')}
                                </Button><br /><br />
                            </div>
                        </Col>
                        <Col xs="8" md="8">
                        <Table
                            name="bonus-table"
                            columns={[
                                {
                                    id: "minPrint",
                                    label: t("InitialLSMark")
                                },
                                {
                                    id: "maxPrint",
                                    label: t("EndLSMark")
                                },
                                {
                                    id: "bonus",
                                    label: t('bonus'),
                                }
                            ]}
                            data={bonusLSDiscount} />
                        </Col>
                    </Row>
                );
            } else {
                return null;
            };
        };
    
        // Bonus Special Table    
        const [bonusTable, setBonusTable] = useState([])
        const [bonus, setBonus] = useState("")
    
        const showBonusSpecialTable = () => {
            const handleClick = () => {
                let obj = [...bonusTable];
                if (maxPrint < 0 || isNaN(maxPrint)){
                    alert(t('alertMaxCost1'))
                } else if (maxPrint < minPrint) {
                    alert(t('alertMaxCost2'))
                } else if (bonus < 0 || isNaN(bonus)) {
                    alert(t('alertBonus'))
                } else {
                    obj.push({"minPrint":minPrint,"maxPrint":maxPrint,"bonus":bonus});
                    setMinPrint(maxPrint+1);
                    setMaxPrint("");
                    setBonus("");
                    setBonusTable(obj);
                }
            };
            const handleClickLess = () => {
                if (bonusTable.length === 0) return;
                let obj = [...bonusTable];
                obj.pop();
                setBonusTable(obj);
                if (obj.length > 0) {
                    let lastRemainingItem = obj[obj.length - 1];
                    setMinPrint(Number(lastRemainingItem.maxPrint) + 1);
                } else setMinPrint(1);
            };
    
            const handleLast = () => {
                let obj = [...bonusTable];
                if (!Math.sign(bonus) || bonus == "") {
                    alert(t('alertBonus'))
                }
                else {
                    obj.push({"minPrint":minPrint,"maxPrint":999999999,"bonus":bonus});
                    setMinPrint("");
                    setMaxPrint("");
                    setBonus("");
                    setBonusTable(obj);
                    setIsLastTier(true);
                }
            };
    
            if (specialConditionType == 2 || specialConditionType == 8 || specialConditionType == 12 || specialConditionType == 15 || specialConditionType == 17){
                return(
                    <Row>
                        <Col xs="4" md="4">
                            <TextBox
                                id="min-print"
                                label={t('bonustable.table1')}
                                maxLength="9"
                                value={minPrint}
                                disabled
                            /><br />
                            <TextBox
                                id="max-print"
                                label={t('bonustable.table2')}
                                maxLength="9"
                                value={maxPrint}
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if (e == "") setMaxPrint(""); else setMaxPrint(parseInt(e)); }}
                                disabled={isLastTier}
                                
                            /><br />
                            <TextBox
                                id="bonus"
                                label="Bonus %"
                                maxLength="3"
                                value={bonus}
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setBonus(e); }}
                                disabled={isLastTier}
                            /><br />
                            <div style={{
                                display: 'flex', 
                                flexDirection: 'column', 
                                gap: '12px', 
                            }}>
                                <Button
                                    id="add-to-bonus-array"
                                    onClick={handleClick}
                                    leadingIcon={<IconPlus />}
                                    disabled={isLastTier}
                                >
                                    {t('addTier')}
                                </Button>
                                <Button
                                    id="less-to-compensation-array"
                                    onClick={handleClickLess}
                                    leadingIcon={<IconMinus />}
                                    disabled={isLastTier}
                                >
                                    {t('clearTier')}
                                </Button>
                                <Button
                                    id="last-bonus-array"
                                    onClick={handleLast}
                                    leadingIcon={<IconListView />}
                                    disabled={isLastTier}
                                >
                                    {t('lastTier')}
                                </Button>
                                <Button
                                    id="clear-bonus-array"
                                    appearance="secondary"
                                    leadingIcon={<IconTrash />}
                                    onClick={() => {
                                        setBonusTable([]);
                                        setMinPrint(1);
                                        setMaxPrint("");
                                        setBonus("");
                                        setIsLastTier(false);
                                    }}
                                >
                                    {t('clearTable')}
                                </Button><br /><br />
                            </div>
                        </Col>
                        <Col xs="8" md="8">
                        <Table
                            name="bonus-table"
                            columns={[
                                {
                                    id: "minPrint",
                                    label: t('bonustable.table1')
                                },
                                {
                                    id: "maxPrint",
                                    label: t('bonustable.table2')
                                },
                                {
                                    id: "bonus",
                                    label: "Bonus",
                                }
                            ]}
                            data={bonusTable} />
                        </Col>
                        <Col xs="4" md="4">
                            <br />
                            <Checkbox
                                id="epm-bonus-table"
                                label="EPM"
                                defaultChecked = {specialConditionType == 12 || specialConditionType == 17}
                                onChange={(e) => {
                                    if (specialConditionType == 2) setSpecialConditionType([12]);
                                    else if ( specialConditionType == 12) setSpecialConditionType([2]);
                                    else if (specialConditionType == 8) setSpecialConditionType([17]);
                                    else if ( specialConditionType == 17) setSpecialConditionType([8]);
                                }}
                            />
                            <br />
                            <Checkbox
                                id="combine-clicks-fixed-bonus"
                                label="Combine Clicks with other client"
                                defaultChecked = {specialConditionType == 8 || specialConditionType == 17}
                                onChange={(e) => {
                                    if (specialConditionType == 2) setSpecialConditionType([8]);
                                    else if (specialConditionType == 8) setSpecialConditionType([2]);
                                    else if (specialConditionType == 12) setSpecialConditionType([17]);
                                    else if (specialConditionType == 17) setSpecialConditionType([12]);
                                }}
                            />
                        </Col>
                    </Row>
                );
            } else {
                return null;
            };
        };
    
        // Fixed Bonus
        const [percentage, setPercentage] = useState()
        const [minimumImp, setMinimumImp] = useState(0)
        let lowCoverageDiscount = [];
        let discontSpecial6kPlus = [];
    
        const showFixedBonus = () => {
            let selectedPresses = pressListBySeriesFilter.filter(press => press.rowConfig.selected === true);
            if(specialConditionType == 23) { // Low Coverage
                if (selectedPresses[0].segment == "L&P") // L&P = 20%
                    lowCoverageDiscount = [{ value: 5, label: '5%' }, { value: 10, label: '10%' }, { value: 15, label: '15%' }, { value: 20, label: '20%' }];
                else // GSP = 15%
                    lowCoverageDiscount = [{ value: 5, label: '5%' }, { value: 10, label: '10%' }, { value: 15, label: '15%' }];
            }
            if (selectedPresses[0].classification.toLowerCase() === '6k+' ) // 6k+ = 40%
                discontSpecial6kPlus = [{ value: 5, label: '5%' }, { value: 10, label: '10%' }, { value: 15, label: '15%' }, { value: 20, label: '20%' },
                    { value: 25, label: '25%' }, { value: 30, label: '30%' }, { value: 35, label: '35%' }, { value: 40, label: '40%' }
                ];
            else // Other Press = 30%
                discontSpecial6kPlus = [{ value: 5, label: '5%' }, { value: 10, label: '10%' }, { value: 15, label: '15%' },
                    { value: 20, label: '20%' }, { value: 25, label: '25%' }, { value: 30, label: '30%' }
                ];
            if (specialConditionType == 3 || specialConditionType == 14 || specialConditionType == 23 || specialConditionType==25){
                return(
                    <Row>
                        {( specialConditionType==3 || specialConditionType==14 ) ? (<>
                            <Col xs="4" md="4">
                                <Select
                                    id="fixed-bonus"
                                    label="Fixed Bonus %"
                                    value={[percentage]}
                                    options={discontSpecial6kPlus}
                                    onChange={(e) => {
                                        setPercentage(e.value);
                                    }}
                                    onClear={() =>{
                                        setPercentage();
                                    }}
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="minimum-impressions"
                                    label={t('bonustable.table1')}
                                    value={minimumImp}
                                    maxLength="9"
                                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                    onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <Checkbox
                                    id="epm-fixed-bonus"
                                    name="epm-fixed-bonus"
                                    label="EPM"
                                    defaultChecked = {specialConditionType == 14}
                                    onChange={(e) => {
                                        if (specialConditionType == 3) setSpecialConditionType([14]);
                                        else if (specialConditionType == 14) setSpecialConditionType([3]);
                                    }}
                                />
                            </Col>
                        </>):(
                        (specialConditionType==23)?(//type 23: Low Coverage Program
                        <>
                            <br />
                            <Col md="12">
                                <h4> {t('bonus')} Low Coverage </h4>
                            </Col>
                            <br />
                            <Col xs="4" md="4">
                                <Select
                                    id="fixed-bonus2"
                                    label="Percentage discount %"
                                    value={[percentage]}
                                    options={lowCoverageDiscount}
                                    onChange={(e) => { setPercentage(e.value); }}
                                    onClear={() =>{ setPercentage(); }}
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="minimum-impressions2"
                                    label="Coverage Below %"
                                    maxLength="9"
                                    value={minimumImp}
                                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                    onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                                />
                            </Col>
                        </>):(//type 25: Frame Width Program
                        <>
                            <br />
                            <Col md="12">
                                <h4> {t('bonus')} Frame Width </h4>
                            </Col>
                            <br />
                            <Col xs="4" md="4">
                                <Select
                                    id="fixed-bonus2"
                                    label="Percentage discount %"
                                    value={[percentage]}
                                    options={[ 
                                        { value: 4, label: '4%' },
                                        { value: 8, label: '5%' },
                                        { value: 6, label: '6%' },
                                        { value: 7, label: '7%' },
                                        { value: 8, label: '8%' }
                                    ]}
                                    onChange={(e) => { setPercentage(e.value); }}
                                    onClear={() =>{ setPercentage(); }}
                                />
                            </Col>
                            <Col xs="4" md="4">
                                <TextBox
                                    id="minimum-impressions2"
                                    label="Coverage Below (mm)"
                                    value={minimumImp}
                                    maxLength="3"
                                    onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                    onChange={(e) => { if(!isNaN(e)) if(e<=660) setMinimumImp(e); }}
                                />
                            </Col>
                        </>)
                        )}
                        <br /> <br />
                    </Row>
                );
            } else if(specialConditionType==27) {
                connectApi
                .getWithParams("api/Channels/getClickTiers",
                {
                    idcustomer: channel[0],
                    idenduser:endUser[0],
                    idpress: seriesList[0].idPress
                    
                }).catch((error) => {
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                        );
                });
            }else {
                return null;
            };
        };
    
        // Tiers Up
        const showTiersUp = () => {
            if (specialConditionType == 4 || specialConditionType == 19){
                return(
                    <Row>
                        <Col xs="4" md="4">
                            <Select
                                id="tiers-up"
                                label="Tiers Up %"
                                value={[percentage]}
                                options={[ 
                                    { value: 5, label: '1 Tier Up - 5%' },
                                    { value: 10, label: '2 Tiers Up - 10%' },
                                    { value: 15, label: '3 Tiers Up - 15%' }
                                ]}
                                onChange={(e) => { setPercentage(e.value); }}
                                onClear={() =>{ setPercentage(); }}
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-impressions"
                                label={t('bonustable.table1')}
                                value={minimumImp}
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumImp(e); }}
                            />
                        </Col>
                    </Row>
                );
            } else {
                return null;
            };
        };
    
        // Run Length
        const [MinimumPrint, setMinimumPrint]=useState(0);
    
        const showRunLength = () => {
            if ( specialConditionType == 21 ){
                return(
                    <Row>
                        <Col xs="4" md="4">
                            <TextBox 
                                label="Minimum Print" 
                                value={MinimumPrint}
                                maxLength="9"
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setMinimumPrint(e); }} 
                            />
                        </Col>
                        {segmentSelected == "L&P"?(
                        <Col xs="4" md="4">
                            <Select
                                id="minimun_metters"
                                label={t('minimumMetters')+" L&P*"}
                                value={minimumImp===0?'':[minimumImp]}
                                options={[ 
                                    { value: 2000, label: t('minimumMetters')+' - 2,000' },
                                    { value: 3000, label: t('minimumMetters')+' - 3,000' },
                                    { value: 3500, label: t('minimumMetters')+' - 3,500' },
                                    { value: 5000, label: t('minimumMetters')+' - 5,000' },
                                    { value: 7500, label: t('minimumMetters')+' - 7,500' },
                                    { value: 10000, label: t('minimumMetters')+' - 10,000' },
                                    { value: 12500, label: t('minimumMetters')+' - 12,500' },
                                    { value: 15000, label: t('minimumMetters')+' - 15,000' }
                                ]}
                                onChange={(e) => {
                                    setMinimumImp(e.value);
                                }}
                                clearIcon={false}
                            />
                        </Col>    
                        ):(
                        <Col xs="4" md="4">
                            <Select
                                id="minimun_sheets"
                                label={t('minimumSheets')+" GCP*"}
                                value={minimumImp===0?'':[minimumImp]}
                                options={[ 
                                    { value: 2000, label: t('minimumSheets')+' - 2,000' },
                                    { value: 2500, label: t('minimumSheets')+' - 2,500' },
                                    { value: 3000, label: t('minimumSheets')+' - 3,000' },
                                    { value: 4000, label: t('minimumSheets')+' - 4,000' },
                                    { value: 5000, label: t('minimumSheets')+' - 5,000' },
                                    { value: 6000, label: t('minimumSheets')+' - 6,000' },
                                    { value: 7000, label: t('minimumSheets')+' - 7,000' }
                                ]}
                                onChange={(e) => {
                                    setMinimumImp(e.value);
                                }}
                                clearIcon={false}
                            />
                        </Col>   
                        )}
                        {series==3?(
                        <Col xs="4" md="4">
                            <TextBox
                                id="bonus_persentage"
                                label={t('bonusPercentageRL')+" *"}
                                maxLength="3"
                                value={percentage || ''}
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setPercentage(e); }}
                            />
                        </Col>    
                        ):(
                        <Col xs="4" md="4">
                            <TextBox
                                id="bonus_persentage"
                                label={t('committedPPIRL')+" *"}
                                maxLength="9"
                                value={percentage || ''}
                                onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e)) setPercentage(e); }}
                            />
                            *{"(" + t('valueCaptureNativeFormat') + ")"}
                        </Col>    
                        )}
                    </Row>
                );
                
            } else {
                return null;
            };
        };
    
        // Combine clicks
        const [channelCombineClicks, setChannelCombineClicks] = useState("")
        const [endUserListCombineClicks, setEndUserListCombineClicks] = useState([])
        const [endUserCombineClicks, setEndUserCombineClicks] = useState("")
        const [endUserNameCombine, setEndUserNameCombine] = useState("")
        const [combineClicksList, setCombineClicksList] = useState([])
        // Fetch data
        const showCombineClicks = () => {
            const handleClick = () => {
                let obj = [...combineClicksList];
                obj.push({"channelCombineClicks":channelCombineClicks[0],"endUserCombineClicks":endUserCombineClicks[0],"endUserName":endUserNameCombine});
                setCombineClicksList(obj);
                setEndUserCombineClicks("");
            };
    
            const handleClear = () => {
                setCombineClicksList([]);
            }
    
            if (specialConditionType == 7 || specialConditionType == 8 || specialConditionType == 17){
                return(
                    <div>
                    <Row>
                        <Col xs="4" md="4">
                            <Select
                            id="channel-list-combine"
                            label={t('channel')}
                            options={channelList}
                            value={channelCombineClicks}
                            disabled
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <Select
                                id="end-user-list-combine"
                                label={t('endUser')}
                                options={endUserListCombineClicks}
                                value={endUserCombineClicks}
                                placeholder={endUserCombineClicks}
                                onChange={(e) => {
                                    setEndUserNameCombine(e.label);
                                    setEndUserCombineClicks([e.value]);
                                }}
                                onClear={() => {
                                    setEndUserCombineClicks("");
                                }}
                                />
                        </Col>
                        <Col xs="4" md="4">
                            <Button
                                id="add-combine-clicks"
                                leadingIcon={<IconPlus />}
                                onClick={handleClick}
                            >
                                {t('addCombineClicks')}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <br />
                        <Table
                            name="bonus-table"
                            columns={[
                                {
                                    id: "endUserCombineClicks",
                                    label: t('endUserId')
                                },
                                {
                                    id: "endUserName",
                                    label: t('endUser')
                                }
                            ]}
                            data={combineClicksList} />
                        </Col>
                        <Col xs="4" md="4">
                            <br />
                            <Button
                                id="clear-combine-clicks"
                                appearance="secondary"
                                leadingIcon={<IconTrash />}
                                onClick={handleClear}
                            >
                                {t('clearCombineClicks')}
                            </Button>
                        </Col>
                    </Row>
                    </div>
                );
            } else {
                return null;
            };
        };
    
        // Minimun Discount
        const [minumimDiscount, setMinumumDiscount] = useState("")
    
        const showMinumimDiscount = () => {
            if (specialConditionType == 11){
                return(
                    <Row>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-discount"
                                label="Minumum Discount %"
                                value={minumimDiscount}
                                maxLength="3"
                                onKeyPress={(event) => { if (event.target.value.replace(/[^0-9]/g, "").length >= 2) event.preventDefault(); }}
                                onChange={(e) => { if(!isNaN(e) || e == '-') setMinumumDiscount(e); }}
                            />
                        </Col>
                    </Row>
                );
            } else {
                return null;
            };
        };

        const configpress=(status,data)=>{
            if ( data.length > 0 ) {
                setOneShotDisabled(!data[0].oneShotVisible);
                setWhiteDisabled(!data[0].whiteVisible);
                setMultiplierConfig(data[0].multiplier);
                setWhiteCpp("");
            } else {
                Swal.fire( "Error ", t("Error_S4"), "error" );            
            }
        }
    // Fin de los Metodos para rellenar las special conditions

    // Metodos para el Review de special conditions
    const showFixedBonusReview = () => {
        if (specialConditionType == 3 || specialConditionType == 14 || specialConditionType == 23 || specialConditionType==25){
            const epmCheckbox = () => {
                //14 represents Fixed Bonus + EPM
                if (specialConditionType == 14) {
                    return  <Checkbox
                        defaultChecked
                        id="checkbox-checked"
                        label="Includes EPM"
                        disabled
                    />
                } 
            }
            return (<>
                {(specialConditionType == 25)?(<>
                    <Row>
                        <Col xs="4" md="4">
                            <TextBox
                                id="fixed-bonus2"
                                label="Percentage discount %"
                                value={percentage}
                                readOnly
                            />
                        </Col>
                        <Col xs="4" md="4">
                            {(specialConditionType == 23)?(<TextBox
                                id="minimum-impressions2"
                                label="Coverage Below %"
                                value={minimumImp}
                                readOnly
                            />):(<TextBox
                                id="minimum-impressions2"
                                label="Coverage Below (mm)"
                                value={minimumImp}
                                readOnly
                            />)}
                        </Col>
                    </Row>
                    <div>{epmCheckbox()}</div>
                </>):(<>
                    <Row>
                        <Col xs="4" md="4">
                            <TextBox
                                id="fixed-bonus"
                                label="Fixed Bonus %"
                                value={percentage}
                                readOnly
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="minimum-impressions"
                                label={t('bonustable.table1')}
                                value={minimumImp}
                                readOnly
                            />
                        </Col>
                    </Row>
                    <div>{epmCheckbox()}</div>
                </>)}
            </>);
        } else return null;
    }
    const showMaxCostPerImpressionReview = () => {
        if (specialConditionType == 1 || specialConditionType == 13 || specialConditionType == 22  || specialConditionType == 23 || specialConditionType==26) {
            let optDecimal = {
                style: 'decimal',
                maximumFractionDigits: 5
            };
            return (<> <br/>
                {(specialConditionType==26)?(
                    <>LSMark Minimum:  {minimumImp}
                    {(percentage>0)?(
                        <>
                        <br />Discount: {percentage}%
                        </>
                    ):(null)}
                    </>
                ):(<></>)}

                {(specialConditionType===26 && percentage>0)?(null):(
                    <>
                        <table className="table table-striped table-hover table-bordered table-sm " >
                            <thead>
                                <tr>
                                    <th scope="col" className="text-center">
                                        {specialConditionType==13 ?("Min LS Mark"):("Min Print")}
                                    </th>
                                    <th scope="col" className="text-center">
                                        {specialConditionType==13 ?("Max LS Mark"):("Max Print")}
                                    </th>
                                    <th scope='col' className='text-center'>Black CPP</th>
                                    <th scope='col' className='text-center'>Other CPP</th>
                                    {(!oneShotDisabled)?(
                                        <th scope='col' className='text-center'>One Shot CPP</th>
                                    ):("")}
                                    {(!whiteDisabled)?(
                                        <th scope='col' className='text-center'>White CPP</th>
                                    ):("")}
                                </tr>
                            </thead>
                            <tbody>
                                {compensationTable.map((row, index)=>{
                                    return (
                                        <tr>
                                            <td scope='col'>{row.minPrint}</td>
                                            <td scope='col'>{row.maxPrint}</td>
                                            <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.blackCpp)}</td>
                                            <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.otherCpp)}</td>
                                            {(!oneShotDisabled)?(
                                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.oneShotCpp)}</td>
                                            ):("")}
                                            {(!whiteDisabled)?(
                                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.whiteCpp)}</td>
                                            ):("")}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        
                        *<label style={{fontSize: '12px'}} >{t("note_table")}</label>
                    </>
                )}<br/>
            </>);
        } else return null;
    }
    
    const showBonusSpecialTableReview = () => {
        if (specialConditionType == 2 || specialConditionType == 8 || specialConditionType == 12 || specialConditionType == 15 || specialConditionType == 17){
            const epm = () => {
                if (specialConditionType == 12 ||  specialConditionType == 17) {
                    return <Checkbox
                        defaultChecked
                        id="checkbox-checked"
                        label="Includes EPM"
                        disabled
                    />
                }
                if (specialConditionType == 15 || specialConditionType == 17) {
                    return <Checkbox
                        defaultChecked
                        id="checkbox-checked"
                        label="Includes All Impresions"
                        disabled
                    />
                }
            }
            return (<><br/>
                <Table id='BonusTable'
                    columns={
                        [
                            
                            {
                                id: 'minPrint',
                                label: 'Min Print',
                            },
                            {
                                id: 'maxPrint',
                                label: 'Max Print',
                            },
                            {
                                id: 'bonus',
                                label: 'Bonus',
                            },
                        ]}
                    data={bonusTable}
                />
                {epm()}<br/>
            </>);
        } else return null;
    }

    const showCombineClicksReview = () => {
         if (specialConditionType == 7 || specialConditionType == 8 || specialConditionType == 17){

            const tiersUp = () => {
                if (specialConditionType == 19) {
                    return percentage;
                }
            }
            const combineClicksTable = () => {
                return <Table
                    columns={[
                        {
                            id: 'endUserName',
                            label: 'Enduser Name',
                        },
                    ]}
                    data={combineClicksList}
                ></Table>
            }

            return (<><br/>
                {combineClicksTable()}
                {tiersUp()}
            <br/></>);
         } else return null; 
    }

    const showTiersUpReview = () => {
        if (specialConditionType == 4 || specialConditionType == 19){
            return (<><br/>
                <Row>
                    <Col xs="4" md="4">
                        <TextBox
                            id="fixed-bonus2"
                            label="Percentage %"
                            value={percentage + " %"}
                            readOnly
                        />
                    </Col>
                    <Col xs="4" md="4">
                        <TextBox
                            id="tiers-up"
                            label="Tiers number"
                            value={percentage / 5}
                            redOnly
                        />
                    </Col>
                    <Col xs="4" md="4">
                        <TextBox
                            id="minimum-impressions"
                            label={t('bonustable.table1')}
                            value={minimumImp}
                            redOnly
                        />
                    </Col>
                </Row>
            <br/></>);
        } else return null; 
    }

    const showMinumimDiscountReview = () => {
        if (specialConditionType == 11){
            return(
                <Row><br/>
                    <Col xs="4" md="4">
                        <TextBox
                            id="minimum-discount"
                            label="Minumum Discount %"
                            value={minumimDiscount}
                            readOnly
                        />
                    </Col>
                <br/></Row>
            );
        } else return null; 
    }

    const showBonusLSDiscountReview = () => {
        if (specialConditionType == 22  || (specialConditionType == 23 && lowCoverage)){
            return (<>
                { bonusLSDiscount.length > 0?(<>
                <br/><br/>
                <table className="table table-striped table-hover table-bordered table-sm " >
                    <thead>
                        <tr>
                            <th scope="col" className="text-center"> InitialLSMark </th>
                            <th scope="col" className="text-center"> FinalLSMark </th>
                            <th scope="col" className="text-center"> Debit / Credit </th>
                        </tr>
                    </thead>
                    <tbody>
                        {bonusLSDiscount.map((row, index)=>{
                            return (
                                <tr>
                                    <td scope='col'>{row.minPrint}</td>
                                    <td scope='col'>{row.maxPrint}</td>
                                    <td scope='col'>{row.bonus}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                </>):(<><br/><br/></>) }
            </>);
        } else return null;
    }

    const showRunLengthReview = () => {
        if ( specialConditionType == 21 ){
            return (<>
                <Row>
                    <Col xs="4" md="4">
                        <TextBox 
                            label="Minimum Print" 
                            value={MinimumPrint}
                            readOnly
                        />
                    </Col>
                    {segmentSelected == "L&P"?(
                    <Col xs="4" md="4">
                        <TextBox
                            id="minimun_metters"
                            label={t('minimumMetters')+" L&P*"}
                            value={minimumImp===0?'':[minimumImp]}
                            readOnly
                        />
                    </Col>    
                    ):(
                    <Col xs="4" md="4">
                        <TextBox
                            id="minimun_sheets"
                            label={t('minimumSheets')+" GCP*"}
                            value={minimumImp===0?'':[minimumImp]}
                            readOnly
                        />
                    </Col>   
                    )}
                    {series==3?(
                    <Col xs="4" md="4">
                        <TextBox
                            id="bonus_persentage"
                            label={t('bonusPercentageRL')+" *"}
                            value={percentage || ''}
                            readOnly
                        />
                    </Col>    
                    ):(
                    <Col xs="4" md="4">
                        <TextBox
                            id="bonus_persentage"
                            label={t('committedPPIRL')+" *"}
                            value={percentage || ''}
                            readOnly
                        />
                        *{"(" + t('valueCaptureNativeFormat') + ")"}
                    </Col>    
                    )}
                </Row>
            </>);
        } else return null;
    }
    //Aqui termina el Reviw de cada CS

    function selectRow(dataArray, checked, id){
        const updatedDataArray = [...dataArray];
        const index = updatedDataArray.findIndex((row) => row.uid === id);
        updatedDataArray[index].rowConfig.selected = checked;
        return updatedDataArray;
    };
    const handleSelect = (event, index) => {
        let selectedPresses = selectRow(pressListBySeriesFilter, event.target.checked, index).filter(press => press.rowConfig.selected === true);
        setPressListBySeriesFilter(selectRow(pressListBySeriesFilter, event.target.checked, index));
        if (selectedPresses.length > 0)
            if ( selectedPresses[0].series >= "4" ) {
                for (let i = 0; i < pressListBySeriesFilter.length; i++){
                    if (pressListBySeriesFilter[i].rowConfig.selected == true) {
                        connectApi.get("api/Channels/getconfigbyserial", {
                            params:{
                                payload:pressListBySeriesFilter[i].idPress.substr(0,4)
                            }
                        }, configpress);
                        break;
                    }
                }
            }
        let selectedAnyPress = pressListBySeriesFilter.filter(x => x.rowConfig.selected === true);
        // verify 6k+
        let filterPressPlus = selectedAnyPress.map(x => x.classification);
        if (selectedAnyPress.length > 0){
            if( filterPressPlus.some(x => x.toLowerCase() === '6k+') && filterPressPlus.some(x => x.toLowerCase() !== '6k+') ){
                setShowMessage(t('different6K+'));
                setPressListBySeriesFilter(selectRow(pressListBySeriesFilter, false, index));
                setShowModalSegment(true);
            } else
                setSelectedPress(true);
        } else
            setSelectedPress(false);
    };

    function selectAllPageItems(tableData, checked) {
        return tableData.map((row) => {
            const newRow = row;
            const index = tableData.findIndex((p) => p.uid === newRow.uid);
            if (index > -1) 
                newRow.rowConfig.selected = checked;
            return newRow;
        });
        }
    const handleSelectAll = (event) => {
        let selectedPresses = selectAllPageItems(pressListBySeriesFilter, event.target.checked).filter(press => press.rowConfig.selected === true);
        setPressListBySeriesFilter(selectAllPageItems(pressListBySeriesFilter, event.target.checked));
        if (selectedPresses.length > 0)
            if ( selectedPresses[0].series >= "4" ) {
                for (let i = 0; i < pressListBySeriesFilter.length; i++){
                    if (pressListBySeriesFilter[i].rowConfig.selected == true) {
                        connectApi.get("api/Channels/getconfigbyserial", {
                            params:{
                                payload:pressListBySeriesFilter[i].idPress.substr(0,4)
                            }
                        }, configpress);
                        break;
                    }
                }
            }
        let selectedAnyPress = pressListBySeriesFilter.filter(x => x.rowConfig.selected === true);
        // verify 6k+
        let filterPressPlus = selectedAnyPress.map(x => x.classification);
        if (selectedAnyPress.length > 0){
            if( filterPressPlus.some(x => x.toLowerCase() === '6k+') && filterPressPlus.some(x => x.toLowerCase() !== '6k+') ){
                setShowMessage(t('runLengthDifferentSegment'));
                setPressListBySeriesFilter(selectAllPageItems(pressListBySeriesFilter, false));
                setShowModalSegment(true);
            } else
                setSelectedPress(true);
        } else
            setSelectedPress(false);
    }
    
    const handleSubmit = () => {
        let selectedPressListToUpload = [];
        for (let i = 0; i < pressListBySeriesFilter.length; i++){
            if (pressListBySeriesFilter[i].rowConfig.selected === true) {
                selectedPressListToUpload.push(pressListBySeriesFilter[i].idPress);
            }
        }
        let combineClicksToUpload = [];
        for (let i = 0; i < combineClicksList.length; i++){
            combineClicksToUpload.push(combineClicksList[i].endUserCombineClicks);
        }
        let data = new FormData();
        data.append("idSpecialConditionType",specialConditionType);
        data.append("idEndUser",endUser);
        data.append("idCustomer",channel);
        if(category==1) data.append("category",'Special Condition');
        else if(category==2) data.append("category",'Ramp up');
        else data.append("category",'Ramp up Ligada');
        data.append("serie",series);
        data.append("endUserContactName",endUserContactName);
        data.append("endUserContactPosition",endUserContactPosition);
        data.append("startDate",(new Date(startDate).getFullYear() + '-' + (new Date(startDate).getMonth() + 1).toString().padStart(2, '0') + '-01'));
        let endateTrasform = new Date(startDate);
        endateTrasform.setMonth(endateTrasform.getMonth() + (Number(effectiveMonths) + 1));
        endateTrasform.setDate(0);
        let secondTransform = endateTrasform.toISOString().split('T')[0];
        data.append("endDate",secondTransform);
        data.append("effectiveMonths",effectiveMonths);
        if((series >= 4) && (specialConditionType === 21))// si es condicion especial 21 y serie 4 o 5 dividimos por su formato y guardamos en porcentaje
            data.append("percentage",((percentage==''?0:percentage)/multiplierConfig)*100);//multiplicamos por 100 porque en el BackEnd lo divide por 100 para guardarlo
        else {
            if ( specialConditionType === 11 ) // Sie es Minimo Discount enviamos el valor porcentual minimo
                data.append("percentage",minumimDiscount);
            else
                data.append("percentage",percentage==''?0:percentage);
        }
        data.append("minimumImp",minimumImp);
        data.append("justification",justification);
        data.append("competition",competition);
        data.append("objetive",objetive);
        data.append("resultFuture",resultFuture);
        data.append("comments",comments);
        data.append("opd",opdNumber);
        data.append("createdBy",endUserEmail);
        data.append("pressList",JSON.stringify(selectedPressListToUpload));
        data.append("compensationTable",JSON.stringify(compensationTable));
        data.append("bonusTable",JSON.stringify(bonusTable));
        data.append("bonusLSDiscountTable",JSON.stringify(bonusLSDiscountSend));
        data.append("combineClicks",JSON.stringify(combineClicksToUpload));
        data.append("minimumPrint",MinimumPrint);
        
        const handleUploadFinal = (status, response) => {
            Swal.fire(
                t('SpConditionSubmitted'),
                "",
                "success"
            );
            resetDefaul();
        }
        
        connectApi.post(
            "api/Channels/UploadSCProcess",
            data,
            handleUploadFinal
        )
        .catch((error) => {
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        });
        const deepcopyItems = defaultJson.map((item) => ({ ...item }));
        setStepItems(deepcopyItems);
        setCurrentIndex(0);
    }
    const defaultJson = [
      {
        label: t('endUserAndPress'),
        status: 'current',
        step: '1',
      }, {
        label: t('infoSpecialCondition'),
        status: 'incomplete',
        step: '2',
      }, {
        label: t('infoProgram'),
        status: 'incomplete',
        step: '3',
      }, {
        label: t('reviewAndSend'),
        status: 'incomplete',
        step: '4',
      },
    ];
    //status: 'disabled' //status: 'incomplete',
    const [stepItems, setStepItems] = useState(defaultJson);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNextButtonOnChange = () => {
        if(currentIndex <= 2){
            const newStepItems = [...stepItems];
            const newSelectedItem = newStepItems[currentIndex + 1];
            const oldSelectedItem = newStepItems[currentIndex];
            newSelectedItem.status = 'current';
            oldSelectedItem.status = 'complete';
            oldSelectedItem.step = <IconCheckmark filled />;

            setCurrentIndex(currentIndex + 1);
            setStepItems(newStepItems);
        } else {
            const deepcopyItems = defaultJson.map((item) => ({ ...item }));
            setStepItems(deepcopyItems);
            setCurrentIndex(0);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  
    const handleResetButtonOnChange = () => {
        if(currentIndex > 0){
            const newStepItems = [...stepItems];
            const newSelectedItem = newStepItems[currentIndex - 1];
            const oldSelectedItem = newStepItems[currentIndex];
            newSelectedItem.status = 'current';
            oldSelectedItem.status = 'complete';

            setCurrentIndex(currentIndex - 1);
            setStepItems(newStepItems);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    
    const handleOnChange = (event, index) => {
        const newStepItems = [...stepItems];
        const newSelectedItem = newStepItems[index];
        const oldSelectedItem = stepItems[currentIndex];
        if (newSelectedItem.status !== 'incomplete'){
            newSelectedItem.status = 'current';
            oldSelectedItem.status = 'pending';
            
            setCurrentIndex(index);
            setStepItems(newStepItems);
        }
      };

    const formStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: 'stretch',
        marginTop: '30px'
    };

    const buttonsContainer = { display: 'flex', justifyContent: 'space-evenly', marginTop: '30px' };
    const nextButtonStyle = { width: '15%' };
    const resetButtonStyle = { width: '15%' };

    const [checkList1, setCheckList1] = useState(false);
    const [checkList2, setCheckList2] = useState(false);
    const [checkList3, setCheckList3] = useState(false);
    const [checkList4, setCheckList4] = useState(false);
    const [checkList5, setCheckList5] = useState(false);
    const [checkList6, setCheckList6] = useState(false);
    const [checkList7, setCheckList7] = useState(false);
    const [checkList8, setCheckList8] = useState(false);

    //View / Render
    return(<> 
        {showModalSegment?(
            <Modal
                id="regular-modal" 
                closeButton
                onClose={() => setShowModalSegment(false)}
                show={showModalSegment}
                title={t('notifyWrongValues')}
            >
                <p>{showMessage}</p>
            </Modal>
            ):null
        }
        <Container style={{margin: "10px 0"}}>
            <h4 style={{marginBottom: "12px"}}>{t('requestSpecialCondition')}</h4>
            {previusInformation?(
                <div>
                     <br /><h6>{t('checklistTitle')}</h6> <br />
                    <Row>
                        <Col xs="12" md="12">
                            <Checkbox 
                                id="checkbox-checked1" 
                                label={t('notBlackMarket')}
                                value={checkList1}
                                onChange={(e) => setCheckList1(e.target.checked)} 
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked2"
                                label={t('pressAgeOrNew')}
                                value={checkList2}
                                onChange={(e) => setCheckList2(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked3"
                                label={t('businessObjective')}
                                value={checkList3}
                                onChange={(e) => setCheckList3(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked4"
                                label={t('customerGrowth')}
                                value={checkList4}
                                onChange={(e) => setCheckList4(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked5"
                                label={t('documentedProject')}
                                value={checkList5}
                                onChange={(e) => setCheckList5(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked6"
                                label={t('noDoubleBenefits')}
                                value={checkList6}
                                onChange={(e) => setCheckList6(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked7"
                                label={t('commercialMaturity')}
                                value={checkList7}
                                onChange={(e) => setCheckList7(e.target.checked)}
                            />
                        </Col>
                        <Col xs="12" md="12">
                            <Checkbox
                                id="checkbox-checked8"
                                label={t('justifiedRequest')}
                                value={checkList8}
                                onChange={(e) => setCheckList8(e.target.checked)}
                            />
                        </Col>
                    </Row>
                    <Row style={{marginTop: '10px'}}>
                        <Col xs="4" md="4">
                            <Select
                                id="objetivo-id"
                                label={t('objective')}
                                value={objetive}
                                options={[
                                    { value: 'Crecimiento de volumen (Print Volume)', label: t('printVolumeGrowth') },
                                    { value: 'Protección contra la competencia', label: t('competitionProtection') },
                                    { value: 'Extensión por instalación de hardware', label: t('hardwareExtension') },
                                    { value: 'Proyecto especial', label: t('specialProject') },
                                ]}
                                onChange={(e) => {setObjetive([e.value])}}
                                clearIcon={false}
                            /><br />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <TextArea
                                id="justification-id"
                                value={justification}
                                label={t('Business Justification')}
                                maxLength="2500"
                                onChange={(e) => {setJustification(e)}}
                            /><br />
                        </Col>
                    </Row>
                    <Row style={{marginTop: '10px'}}>
                        <Col xs="4" md="4">
                            <TextBox
                                id="nameSend"
                                label={t('created_by')}
                                value={endUserContactName}
                                redOnly
                            />
                        </Col>
                        <Col xs="4" md="4">
                            <TextBox
                                id="dateSend"
                                label={t('dateCreate')}
                                value={new Date().toISOString().split('T')[0]}
                                redOnly
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <Button 
                                style={{marginTop: '15px'}} 
                                onClick={() => setPreviusInformation(false)}
                                disabled={!(checkList1 && checkList2 && checkList3 && checkList4 
                                    && checkList5 && checkList6 && checkList7 && checkList8 && objetive != "" && justification != "")}
                            >{t('next')}</Button>
                        </Col>
                    </Row>
                </div>
            ):(
                <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                    <Stepper interactive onChange={handleOnChange} steps={stepItems} />
                    <div style={formStyle}>
                    <ThemeProvider density="high">
                        {currentIndex == 0 ? (<>
                            <Row>
                                <Col xs="4" md="4">
                                    <Select
                                        id="category-list"
                                        options={[{value: 1, label: 'Special condition'}, {value: 2, label: 'Ramp up'}, {value: 3, label: 'Ramp up Ligada'}]}
                                        value={category}
                                        placeholder={t('category')}
                                        onChange={(e) => {setCategory([e.value]); if(e.value=="1") setOpdNumber("")}}
                                        onClear={() => setCategory([])}
                                        readOnly={viewChannel}
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <Select
                                        id="channel-list"
                                        label={t('channel')}
                                        options={channelList}
                                        value={channel}
                                        placeholder={t('channel')}
                                        onChange={(e) => { setChannel([e.value]); fetchEndUsers(e.value); setChannelCombineClicks([e.value])}}
                                        disabled={!category[0]}
                                        readOnly={viewChannel}
                                    />
                                </Col>
                            </Row>
                            {(category[0] == '2' )?(<>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="opd-number"
                                            value={opdNumber}
                                            label="OPD #"
                                            maxLength="14"
                                            onKeyPress={(event) => {
                                                if (opdNumber.length < 3) if (!/^[A-Za-z]+$/.test(event.key)) event.preventDefault();
                                                else if (!/[0-9]/.test(event.key)) event.preventDefault();
                                            }}
                                            onChange={(e) => {
                                                setOpdNumber(e);
                                                if (opdNumber.length == 3) setOpdNumber(opdNumber + "-")
                                            }}
                                        />
                                    </Col>
                                    <Col xs="4" md="4">
                                        <FilePicker 
                                            id="Files"
                                            label={t('selectFile')}
                                            accept=".pdf"
                                            onChange={(event) => {setFile(event.target.files[0]);}}
                                        />
                                    </Col>
                                </Row>
                            </>):(category[0] == '3' )?(<>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="opd-number"
                                            value={opdNumber}
                                            label="OPD #"
                                            maxLength="14"
                                            onKeyPress={(event) => {
                                                if (opdNumber.length < 3) if (!/^[A-Za-z]+$/.test(event.key)) event.preventDefault();
                                                else if (!/[0-9]/.test(event.key)) event.preventDefault();
                                            }}
                                            onChange={(e) => {
                                                setOpdNumber(e);
                                                if (opdNumber.length == 3) setOpdNumber(opdNumber + "-")
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </>):(<></>)}
                            <Row style={{marginTop: "20px"}}>
                                <Col xs="4" md="4">
                                    <Select
                                        id="endUser-list"
                                        label={t('endUserName')}
                                        options={endUserList}
                                        value={endUser}
                                        placeholder={t('endUserName')}
                                        disabled={channel==""}
                                        onChange={(e) => {setEndUser([e.value]); fetchPress(e.value)}}
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    <Select
                                        id="Segmento-list"
                                        options={[{value: "GCP", label:"Commercial"},{value: "L&P", label:"Labels & Packaging"}]}
                                        value={segment}
                                        placeholder={t('segment')}
                                        disabled={endUser==""}
                                        onChange={(e) => { setSegmentFind(e.value)}}
                                        readOnly={segmentFlag}
                                    />
                                </Col>
                                <Col xs="4" md="4">
                                    {seriesList.length > 1 ? (
                                        <Select
                                            id="series-list"
                                            label={t("series")}
                                            options={seriesList}
                                            value={series}
                                            placeholder={t("series")}
                                            onChange={(e) => { fetchSpConditions(e.value); }}
                                        />
                                    ):(null)}
                                </Col>
                            </Row>
                            { (Number(series) != 0 && segment != "") ? (
                                Number(series) >= 3 ?(<>
                                    <Row style={{marginTop: "20px"}}>
                                        <Col xs="12" md="12">
                                            {pressListBySeriesFilter.length > 0 ? (
                                                <Table
                                                    name="press-table"
                                                    rowSelector="multiSelection"
                                                    onSelect={handleSelect}
                                                    rowSelectAllState={selectionState(pressListBySeriesFilter)}
                                                    onSelectAllPageItems={handleSelectAll}
                                                    columns={[
                                                        { id: "uid", index:"hidden" }, 
                                                        { id: "idPress", label: t('press id'), }, 
                                                        { id: "classification", label: t('classification'), }, 
                                                        { id: "series", label: t("series"), }, 
                                                        { id: "segment", label: t('segment'), }, 
                                                        { id: "installDate", label: t('installationDate'), }, 
                                                        { id: "dateEndUser", label: t('dateEndUser'), }, 
                                                        { id: "program", label: t('bonustable.table4'), }
                                                    ]}
                                                    data={pressListBySeriesFilter} 
                                                />
                                            ):(null)}<br />
                                        </Col>
                                    </Row>
                                </>) : (<><br /><h5>{t('applaySpecialCondition')}</h5></>)
                            ):(null) }
                        </>) 
                        : currentIndex == 1 ? (<>
                            <Row>
                                <Col xs="4" md="4">
                                    <Select
                                        id="special-condition-type-list"
                                        label={t('Special Condition Type')}
                                        options={specialConditionTypeList}
                                        value={specialConditionType}
                                        onChange={(e) => { setSpecialConditionType([e.value]); }}
                                        onClear={() => setSpecialConditionType("") }
                                    /><br />
                                </Col>
                                {specialConditionType?(<>
                                    <Tooltip placement="top" contentHideDelayOnHover={0} content="--Info SPT--">
                                        <IconInfo size={16} />
                                    </Tooltip>
                                </>):(<></>)}
                            </Row>
                            {specialConditionType?(<>
                                <div >
                                    {showFixedBonus()}
                                    {showMaxCostPerImpression()}
                                    {showBonusSpecialTable()}
                                    {showCombineClicks()}
                                    {showTiersUp()}
                                    {showMinumimDiscount()}
                                    {showBonusLSDiscount()}
                                    {showRunLength()}
                                </div>
                            </>):(<></>)}
                        </>) 
                        : currentIndex == 2 ? (<>
                            <Row>
                                    <Col xs="4" md="4">
                                        <DatePicker
                                            id="stardate-id"
                                            label={t("specialcondition.startdate")}
                                            placeholder="YYYY-MM"
                                            format="YYYY-MM"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e)}
                                            //calendarOrientation={['up']}
                                            monthYearNavigation={true}
                                            blockPastDates={true} 
                                        /><br />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="effective-months"
                                            value={effectiveMonths}
                                            label={t('effMonth')}
                                            maxLength="2"
                                            disabled={!startDate}
                                            onKeyPress={ (event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); } }
                                            onChange={ (e) => { if (e != 0) setEffectiveMonths(e); else setEffectiveMonths(1); }  }
                                        /><br />
                                    </Col>
                                </Row>

                                {category[0] == '2' || category[0] == '3' ? (<></>):(<>
                                    {informationFromHP?(<></>):(<>
                                        <Row>
                                            <Col xs="4" md="4">
                                                <Select
                                                    id="objetivo-id"
                                                    label={t('objective')}
                                                    value={objetive}
                                                    options={[
                                                        { value: 'Crecimiento de volumen (Print Volume)', label: t('printVolumeGrowth') },
                                                        { value: 'Protección contra la competencia', label: t('competitionProtection') },
                                                        { value: 'Extensión por instalación de hardware', label: t('hardwareExtension') },
                                                        { value: 'Proyecto especial', label: t('specialProject') },
                                                    ]}
                                                    onChange={(e) => {setObjetive([e.value])}}
                                                    clearIcon={false}
                                                /><br />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="12" md="12">
                                                <TextArea
                                                    id="justification-id"
                                                    value={justification}
                                                    label={t('Business Justification')}
                                                    maxLength="2500"
                                                    onChange={(e) => {setJustification(e)}}
                                                /><br />
                                            </Col>
                                        </Row>
                                    </>)}
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextBox
                                                id="competition-id"
                                                value={competition}
                                                label={t('Competition')}
                                                onChange={(e) => {setCompetition(e)}}
                                            /><br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextArea
                                                id="resultado-id"
                                                value={resultFuture}
                                                label={t('expectedResult')}
                                                maxLength="2500"
                                                onChange={(e) => {setResultFuture(e)}}
                                            /><br />
                                        </Col>
                                    </Row>
                                </>)}
                                
                                <Row>
                                    <Col xs="12" md="12">
                                        <TextArea
                                            id="comentarios-id"
                                            value={comments}
                                            label={t('comments')}
                                            maxLength="2500"
                                            onChange={(e) => {setComments(e)}}
                                        /><br />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="contact-name"
                                            value={endUserContactName}
                                            label={t('contactName')}
                                            maxLength = "100"
                                            onChange={(e) => {setEndUserContactName(e)}}
                                            required
                                        />
                                    </Col>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="contact-position"
                                            value={endUserContactPosition}
                                            label={t('jobPosition')}
                                            maxLength="100"
                                            onChange={(e) => {setEndUserContactPosition(e)}}
                                            required
                                        /><br />
                                    </Col>
                                </Row>
                        </>) 
                        : currentIndex == 3 ? (<>
                            <Container style={{margin: "10px 0"}}>
                                <h4 style={{marginBottom: "12px"}}>{t('End User and Press Information')}</h4>
                                <Row>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="idCategory"
                                            value={category == 1 ? 'Special Condition' : category == 2 ? 'Ramp up' : 'Ramp Up Ligada'}
                                            label={t('category')}
                                            readOnly
                                        />
                                    </Col>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="idChannel"
                                            value={channelList.find(x => x.value == channel).label}
                                            label={t('channel')}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="idEnduser"
                                            value={endUserList.find(x => x.value == endUser).label}
                                            label={t('endUserName')}
                                            readOnly
                                        />
                                    </Col>
                                    {category == 2 ? (<>
                                        <Col xs="4" md="4">
                                            <TextBox
                                                id="idOpdNumber"
                                                value={opdNumber}
                                                label="OPD #"
                                                readOnly
                                            />
                                        </Col>
                                    </>):(<></>)}
                                </Row>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="12" md="12">
                                        <Table
                                            name="press-table2"
                                            columns={[ 
                                                { id: "uid", index:"hidden" },
                                                { id: "idPress", label: t('press id'), }, 
                                                { id: "classification", label: t('classification'), }, 
                                                { id: "series", label: t("series"), }, 
                                                { id: "segment", label: t('segment'), }, 
                                                { id: "installDate", label: t('installationDate'), }, 
                                                { id: "dateEndUser", label: t('dateEndUser'), }
                                            ]}
                                            data={pressListBySeriesFilter}
                                        />
                                    </Col>
                                </Row>
                                <Row style={{marginTop: "20px"}}>
                                    <Col xs="4" md="4">
                                        <DatePicker
                                            id="idStartDate"
                                            value={startDate}
                                            format="YYYY-MM"
                                            label={t("specialcondition.startdate")}
                                            disabled
                                        />
                                    </Col>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="idEffectiveMonth"
                                            value={effectiveMonths}
                                            label={t('effMonth')}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                                <div style={{marginTop: "20px", marginBottom: "20px"}}>
                                    {showFixedBonusReview()}
                                    {showMaxCostPerImpressionReview()}
                                    {showBonusSpecialTableReview()}
                                    {showCombineClicksReview()}
                                    {showTiersUpReview()}
                                    {showMinumimDiscountReview()}
                                    {showBonusLSDiscountReview()}
                                    {showRunLengthReview()}
                                </div>

                                {category[0] == '2' || category[0] == '3' ? (<></>):(<>
                                    <Row>
                                        <Col xs="4" md="4">
                                            <TextBox
                                                id="objetivo-id"
                                                value={objetive}
                                                label={t('objective')}
                                                readOnly
                                            /><br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextArea
                                                id="justification-id"
                                                value={justification}
                                                label={t('Business Justification')}
                                                readOnly
                                            /><br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextBox
                                                id="competition-id"
                                                value={competition}
                                                label={t('Competencia')}
                                                readOnly
                                            /><br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <TextArea
                                                id="resultado-id"
                                                value={resultFuture}
                                                label={t('expectedResult')}
                                                readOnly
                                            /><br />
                                        </Col>
                                    </Row>
                                </>)}
                                
                                <Row>
                                    <Col xs="12" md="12">
                                        <TextArea
                                            id="comentarios-id"
                                            value={comments}
                                            label={t('comments')}
                                            readOnly
                                        /><br />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="4" md="4">
                                        <TextBox
                                            id="contact-name"
                                            value={endUserContactName}
                                            label={t('contactName')}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </>):(<></>)}
                    </ThemeProvider>
                    <div style={buttonsContainer}>
                        <Button
                            name="reset"
                            customStyle={resetButtonStyle}
                            small
                            onClick={handleResetButtonOnChange}
                            disabled={currentIndex == 0}
                        >
                        {t('back')}
                        </Button>
                        {currentIndex == 3 ? (<>
                            <Button
                                name="sendData"
                                customStyle={nextButtonStyle}
                                small
                                title={t('Submit')}
                                onClick={handleSubmit}
                            >
                                {t('Submit')}
                            </Button>
                        </>):(<>
                            <Button
                                name="button"
                                customStyle={nextButtonStyle}
                                small
                                onClick={handleNextButtonOnChange}
                                disabled={!selectedPress}
                            >
                            {t('next')}
                            </Button>
                        </>)}
                    </div>
                    </div>
                </div>
            )}
        </Container>
    </>);
}

export default NewSpecialConditionsProcess;